import React, { useState, useContext } from "react";
import { RootContext } from "../../../RootContextProvider";
import { Link } from "react-router-dom";
import { Button, message, Row, Col, Input, Form } from "antd";
import "./../../addNewLinkRegular/AddNewLinkRegular.css";
import { verticalFormLayout } from "../../../utils/forms";
import { addNewLinkToPage, updateLink, deleteLink } from "../../../utils/links";
import "../ModalLinkCreation.css";
import { SiDeezer } from "react-icons/si";
import TextArea from "antd/lib/input/TextArea";
import PremiumTag from "../../Billing/PremiumTag";
import { validateWidthDeezer } from "../../../utils/utils";
import { DeleteOutlined, ArrowLeftOutlined } from "@ant-design/icons";

const Deezer = ({
  setModalOpen,
  isEdittingLink,
  setEdittingLink,
  linkEditDetails,
  currentLinks,
  setRefresh,
  refresh,
  setDisplayBlockPicker,
}) => {
  const [form] = Form.useForm();

  const [loading] = useState(false);
  //   const [needUpgrade, setNeedUpgrade] = useState(false);
  const { pages, account } = useContext(RootContext);
  //   let history = useHistory();

  if (isEdittingLink) {
    console.log("editing mode");
    form.setFieldsValue({
      url: linkEditDetails.LinkUrl,
      title: linkEditDetails.LinkTitle,
      embedCode: linkEditDetails.LinkEmbedCode,
    });
  } else {
    console.log("normal mode");
    form.setFieldsValue({
      url: "",
      title: "",
      embedCode: "",
    });
    // form.resetFields();
  }
  const onFinish = async (values) => {
    if (values.embedCode.includes("https://www.deezer.com/plugins/")) {
      let isWidthValid = await validateWidthDeezer(values.embedCode);
      if (isWidthValid) {
        if (!isEdittingLink) {
          let linkDetails = {
            type: "deezer",
            title: values.title,
            url: values.url,
            embedCode: values.embedCode,
            index: currentLinks ? currentLinks.length : 0,
          };
          await addNewLinkToPage(pages.PageID, linkDetails);

          setRefresh(refresh + 1);
        } else {
          // update link info
          // close modal
          let linkDetails = {
            id: linkEditDetails.LinkID,
            type: linkEditDetails.LinkType,
            title: values.title,
            url: values.url,
            embedCode: values.embedCode,
            index: linkEditDetails.LinkIndex,
          };
          console.log(linkDetails);
          let isUpdated = await updateLink(pages.PageID, linkDetails);
          if (isUpdated.message) {
            message.success("Lien modifié avec succès");
            setEdittingLink(false);
            setRefresh(refresh + 1);
          } else {
            message.error("Erreur lors de la modification");
          }
        }

        setModalOpen(false);
      } else {
        message.error(
          "Votre iframe Deezer doit être inférieure ou égale à 360px."
        );
      }
    } else {
      message.error("Votre lien embed Deezer est incorrect");
    }
  };

  const onFinishFailed = async () => {
    console.log("Bugggg");
  };

  const delLink = async () => {
    try {
      let deletedLink = await deleteLink(pages.PageID, linkEditDetails.LinkID);
      if (deletedLink.message) {
        message.success("Bloc supprimé avec succès");
        setRefresh(refresh + 1);
      } else {
        message.error("Erreur lors de la suppression");
      }
    } catch (e) {
      console.log(e);
    } finally {
      cancelModal();
    }
  };

  const cancelModal = () => {
    setModalOpen(false);
    setTimeout(() => {
      setEdittingLink(false);
    }, 200);
  };

  return (
    <div>
      <div className="modal-header">
        <Row>
          <Col span={2} className="back-link">
            {!isEdittingLink ? (
              <div
                onClick={() => {
                  setDisplayBlockPicker(true);
                }}
              >
                <ArrowLeftOutlined style={{ marginRight: "5px" }} />
              </div>
            ) : (
              ""
            )}
          </Col>
          <Col span={20}>
            <div className="modal-title">
              <SiDeezer className="icon-modal-title" /> Paramètrez votre bloc
              Deezer
              {!account.IsPaying ? (
                <div className="premium-block">
                  <PremiumTag size="medium" hasIcon={false} />
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
      <div className="modal-body">
        <Form
          className="form-signup align-left"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          {...verticalFormLayout}
        >
          <Form.Item
            label="Titre"
            name="title"
            rules={[
              { required: true, message: "Insérez votre titre" },
              {
                max: 35,
                message: "Votre titre doit faire 35 caractères maximum.",
              },
            ]}
          >
            <Input className="auth-input" placeholder="Deezer" maxLength={35} />
          </Form.Item>
          <Form.Item
            label="Deezer Embed Code"
            name="embedCode"
            rules={[
              {
                required: true,
                message: "Insérez votre Deezer Embed Code",
              },
            ]}
          >
            <TextArea
              rows={3}
              maxLength={2000}
              className="auth-input"
              placeholder="Ajoutez votre Deezer Embed Code"
            />
          </Form.Item>
          {!account.IsPaying ? (
            <div className="upgrade-explain">
              Veuillez <Link to="/billing">passer au plan premium</Link> pour
              débloquer le bloc Deezer.
            </div>
          ) : (
            ""
          )}
          <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              className="submit-link"
              htmlType="submit"
              loading={loading}
              size="large"
              disabled={account.IsPaying ? false : true}
            >
              Sauvegarder
            </Button>

            {isEdittingLink ? (
              <div
                className="del-link-mobile"
                onClick={() => {
                  delLink();
                }}
              >
                <DeleteOutlined style={{ marginRight: "5px" }} />
                Supprimer
              </div>
            ) : (
              ""
            )}
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Deezer;
